/* eslint-disable react-hooks/exhaustive-deps */
import React ,{useEffect} from 'react'
import classes from './RegulationsInternational.module.scss'
import BreadCrumb from '../../../components/BreadCrumb'
// import FileCard from '../../../components/FileCard'
import {NavLink,Outlet,useNavigate} from 'react-router-dom'
export default function RegulationsInternational() {
    const navigate = useNavigate()
    useEffect(() => {
      navigate('/international-regulations/international-conventions')
    }, [])
    return(
    <div className={` ${classes.RegulationsInternational} load-anim`}>
            <BreadCrumb
                list={[
                    { title: "Bosh sahifa", path: "/" },
                    { title: "Me'yoriy huquqiy hujjatlar", path: "/regulations" },
                    {
                        title: "Xalqaro hujjatlar",
                        path: "/international-regulations",
                    },
                ]}
            />
            <div className={`container ${classes.RegulationsInternational_container}`}>
                <div className={classes.RegulationsInternational_container_title}>
                    <h1>XALQARO HUJJATLAR</h1>
                </div>
                <div className={classes.RegulationsInternational__wrapper}>
                <div className={classes.RegulationsInternational_container_button}>
                    <NavLink className={classes.text} to='/international-regulations/international-conventions' >XALQARO KONVENSIYALAR</NavLink>
                    <NavLink className={classes.text} to='/international-regulations/intergovernmental-agreements' >HUKUMATLARARO BITIMLAR</NavLink>
                </div>
                </div>
                <Outlet/>
            </div>
        </div>
    )
    
}